import React, { useState,useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import MeteoData from './MeteoData';
import MeteoAlarmas from './MeteoAlarmas';
import MeteoParametrizacion from "./MeteoParametrizacion";
import MeteoHistoricos from './MeteoHistoricos';
import './VerMeteo.css';
import { useTranslation } from 'react-i18next';

function VerMeteo() {
    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    const { t } = useTranslation();
    if (code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }
    
    window.addEventListener("orientationchange", function(){
        window.location.reload();
    });

    //Deshabilitar el link si no hay pantalla de inversor
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "ParamsMet");
    const [paramsDisabled,setParamsDisabled] = useState(<></>);

    useEffect(() => {
        if(screen[0].Enabled === true){
        setParamsDisabled(
            <Tab eventKey="parametrizacion" title={t('scada.solarFarm.meteo.parameterization')}>
                    <MeteoParametrizacion code={code} />
            </Tab>
        );
        }
    },[]);


    return (
        <div className='div-tabs-meteo'>
            <Tabs defaultActiveKey="datos">
                <Tab eventKey="datos" title={t('scada.solarFarm.meteo.data')}>
                    <MeteoData code={code} />
                </Tab>
                <Tab eventKey="alarmas" title={t('scada.solarFarm.meteo.alarm')}>
                    <MeteoAlarmas code={code} />
                </Tab>
                {paramsDisabled}
                <Tab eventKey="historicos" title={t('scada.solarFarm.meteo.historical')}>
                    <MeteoHistoricos code={code} />
                </Tab>
            </Tabs>
        </div>
    );
};

export default VerMeteo;